import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Inicializar autenticación al cargar la app
import { useAuthStore } from './stores/auth'
const authStore = useAuthStore()
authStore.initializeAuth()

app.mount("#app")


// ✅ Registrar el Service Worker
if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .register('/service-worker.js?v=1.0.4')
        .then(() => {
            // console.log('✅ Service Worker registrado correctamente');
        })
        .catch((err) => {
            console.error('❌ Error al registrar el Service Worker:', err);
        });
}